import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

import { AttachmentItem } from '../types';

@Component({
  selector: 'chat-attachment-preview',
  templateUrl: './attachment-preview.component.html',
  styleUrls: ['./attachment-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class AttachmentPreviewComponent {
  @Input() attachmentPreview?: AttachmentItem[];
}
